import { generateSetChild } from '@/helpers/VuexHelpers'
import { service } from '@/service/index'
import { dayjs, dayjsLocal } from "@/helpers/dayjs"
import CheckoutTimeUtil from '@/helpers/CheckoutTimeUtil'
import { config } from '@/config'
import { switchDateFormat } from '@/utils/formatDate'

window.dayjs = dayjs
//helper instance
let timeUtil = new CheckoutTimeUtil()

export default {
	namespaced: true,
	state: {
		checkoutToken: "",
		serverData: "",
		shippings: null,
		payments: [],
		billingAddress: {},
		shippingAddress: {},
		orderDate: null,
		deliveryDates: [],
		deliveryMethods: [],
		deliveryMethod: null
	},
	actions: {
		async summary({commit, state, dispatch, rootState}, {accumulatorGroup = null} = {}) {
			await dispatch('cart/restoreCart', null, { root: true})
			const cart = await service.checkoutSummary({token: rootState.cart.basketToken, channel: rootState.cart.basketChannel, accumulatorGroup})
			commit('setData', {item: cart})
			dispatch('cart/readCart', { cart }, { root: true})

		},
		async addressChange({state, dispatch, commit, rootState}, { shippingAddress, billingAddress, email, accumulatorGroup = 'orderSubmit' } = {}) {
			await service.checkoutAddressChange({token: rootState.cart.basketToken,	shippingAddress, billingAddress, email, channel: rootState.cart.basketChannel, accumulatorGroup})
		},
		async payments({state, dispatch, commit, rootState}, { accumulatorGroup = null } = {}) {
			let paymentsMap = await service.checkoutPayments({token: rootState.cart.basketToken, channel: rootState.cart.basketChannel, accumulatorGroup})
			//HACK: fix serverside problem
			if(paymentsMap instanceof Array) {
				paymentsMap = { "payments": [] }
			}

			//HACK: we use only the first payment
			let payments = paymentsMap.payments.length
				? Object.values(paymentsMap.payments[0].methods)
				: []

			commit('setPayments', {item: payments})
			return payments
		},
		async setPayment({state, dispatch, rootState}, { method, accumulatorGroup = 'orderSubmit' } = {}) {
			await service.checkoutPaymentChange({token: rootState.cart.basketToken, method, channel: rootState.cart.basketChannel, accumulatorGroup})
		},
		async shipping({state, dispatch, commit, rootState}) {
			let shipping = await service.checkoutShippings({token: rootState.cart.basketToken, channel: rootState.cart.basketChannel})
			commit('setShippings', shipping)
			return shipping
		},
		async setShipping({state, commit, dispatch, rootState, rootGetters}, { street, streetNumber, city, postcode, accumulatorGroup = 'orderSubmit' } = {}) {
			const result = await service.checkoutShippingChange({token: rootState.cart.basketToken, street, streetNumber, city, zip: postcode, accumulatorGroup })
			if (Array.isArray(result)) {
				commit('setDeliveryMethods', {item: result.map(method => {
					return {
						...method,
						deliveryDates: method.deliveryDates?.deliveryDates ?? method.deliveryDates
					}
				})})
				commit('setDeliveryMethod', {item: state.deliveryMethod ?? rootGetters['cart/shippingMethod']?.code ?? result[0]?.code})
			} else {
				commit('setDeliveryDates', {item: result.deliveryDates})
			}
		},
		async setDeliveryMethod({state, commit}, { code }) {
			if (state.deliveryMethods.find(m => m.code === code)) {
				commit('setDeliveryMethod', {item: code})
			}
		},
		async submit({state, dispatch, rootState, commit}, { email, notes, tip = 0, confirmedAlcohol = false, dropoffType, newsletter, birthday = null, chopsticks = false, accumulatorGroup = 'orderSubmit' } = {}) {
			await service.checkoutSubmit({ token: rootState.cart.basketToken, email, notes, dropoffType, newsletter, birthday, chopsticks, channel: rootState.cart.basketChannel, confirmedAlcohol, tip, accumulatorGroup })
			commit('setCheckoutToken', {item: rootState.cart.basketToken})
		},
		async order({state, dispatch, commit, rootState}, { accumulatorGroup = 'orderSubmit' } = {}) {
			let order = await service.orderShow({ token: state.checkoutToken, channel: rootState.cart.basketChannel, accumulatorGroup })
			commit('setData', {item: order})
			return order
		},
		async addressAutocomplete(_vuex, { street, streetNumber, postcode, accumulatorGroup = null } = {}) {
			return await service.addressAutocomplete({ street, streetNumber, postcode, accumulatorGroup })
		}
	},
	getters: {
		checkoutState(state, getters, rootState) {
			return rootState.cart.serverData
				? rootState.cart.serverData.checkoutState
				: "none"
		},
		checkoutPayments(state) {
			return state.payments
		},
		checkoutShippings(state) {
			return state.shippings
		},
		checkoutFormData(state, getters, rootState) {
			return rootState.cart.serverData
				? {
					shippingAddress: rootState.cart.serverData.shippingAddress,
					billingAddress: rootState.cart.serverData.billingAddress,
					billingAddressIdentical: rootState.cart.serverData.billingAddressIdentical,
					email: rootState.cart.serverData.email,
					deliverNow: rootState.cart.serverData.deliverNow,
					deliverTime: rootState.cart.serverData.deliverTime,
					notes: rootState.cart.serverData.notes,
					dropoffType: rootState.cart.serverData.dropoffType,
					paymentCode: rootState.cart.serverData.payments.length
						? rootState.cart.serverData.payments[0].method.code
						: "",
					chopsticks: rootState.cart.serverData.chopsticks,
				}
				: null
		},
		checkoutBasketZip(state, getters, rootState) {
			if (!rootState.cart.serverData) {
				return null
			}
			return rootState.cart.serverData.zip
				? rootState.cart.serverData.zip.zip
				: null
		},
		checkoutDeliveryDates(state) {
			return (state.deliveryDates || [])
				.filter(d => d.timeslots?.length)
				.map(d => {
					return {
						deliveryDate: switchDateFormat(d.deliveryDate, '.'),
						timeslots: d.timeslots.map(slot => {
							const from = slot.from.split(':').slice(0,2).join(':');
							const to = slot.to.split(':').slice(0,2).join(':');
							return {
								surcharge: slot.surcharge,
								label: slot.label,
								productCode: slot.productCode,
								from,
								to,
								slot: `${from} - ${to}`
							}
						})
					}
				})
		},
		checkoutDeliveryMethods(state) {
			return (state.deliveryMethods || [])
				.map(method => {

					return {
						...method,
						deliveryDates: method.deliveryDates
							.filter(d => d.timeslots?.length)
							.map(d => {
								return {
									deliveryDate: switchDateFormat(d.deliveryDate, '.'),
									timeslots: d.timeslots.map(slot => {
										const from = slot.from.split(':').slice(0,2).join(':');
										const to = slot.to.split(':').slice(0,2).join(':');
										return {
											price: slot.price,
											surcharge: slot.surcharge,
											label: slot.label,
											productCode: slot.productCode,
											from,
											to,
											slot: `${from} - ${to}`
										}
									})
								}
							})
					}
				})
		},
		checkoutDeliveryMethod(state, getters) {
			return getters.checkoutDeliveryMethods.find(m => m.code === state.deliveryMethod) || getters.checkoutDeliveryMethods[0]
		},
	},
	mutations: {
		setCheckoutToken: generateSetChild("checkoutToken"),
		setData: generateSetChild("serverData"),
		setPayments: generateSetChild("payments"),
		setShippings: generateSetChild("shippings"),
		setOrderDate: generateSetChild("orderDate"),
		setDeliveryDates: generateSetChild("deliveryDates"),
		setDeliveryMethod: generateSetChild("deliveryMethod"),
		setDeliveryMethods: generateSetChild("deliveryMethods"),
	}
}
